// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"c8169640","135":"5e5bd861","145":"2ceee4ec","195":"fda381fd","267":"9bfab47d","490":"729cc9e6","518":"1ea8ce98","631":"93da0d0f","785":"92a77bde","787":"c3654f5f"}[chunkId] + ".chunk.js";
};